import React, { useState, useEffect } from "react";
import { Box, IconButton, Rating, Alert, Snackbar } from "@mui/material";
import { Axios } from "../../../Api/axios";
import Cookie from "cookie-universal";
import { TESTIMONIAL } from "../../../Api/Api";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Pusher from "pusher-js";

const cookie = Cookie();
const token = cookie.get("dashboardLogin");
const userRole = cookie.get("userRole");

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#098040",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function TestimonialTable() {
  const [alert, setAlert] = useState(null);
  const [alertVisible, setAlertVisible] = useState(true);
  const [testi, setTesti] = useState([]);
  const [pendingTesti, setPendingTesti] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    const pusher = new Pusher("370efa04537ac4362e39", {
      cluster: "eu",
      encrypted: true,
    });

    const channel = pusher.subscribe("testimonials");

    channel.bind("NewComment", (data) => {
      setOpenAlert(true);
      setPendingTesti((prev) => [data.comment, ...prev]);

      setTimeout(() => setOpenAlert(false), 4000);
    });

    return () => {
      pusher.unsubscribe("testimonials");
    };
  }, []);

  useEffect(() => {
    fetchTesti();
  }, []);

  const fetchTesti = async () => {
    try {
      const response = await Axios.get(`/panel/${TESTIMONIAL}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "X-User-Role": userRole,
        },
      });

      console.log(response.data); // Check what the API returns

      if (Array.isArray(response.data)) {
        const accepted = response.data.filter((t) => t.is_accepted);
        const pending = response.data.filter((t) => !t.is_accepted);

        setTesti(accepted);
        setPendingTesti(pending);
      } else {
        console.error("API did not return an array:", response.data);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const handleAccept = async (id) => {
    try {
      const response = await Axios.patch(
        `/panel/${TESTIMONIAL}/${id}/accept`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-User-Role": userRole,
          },
        }
      );

      setAlert({
        message: "Comment Accepted successfully",
        severity: "success",
      });
      fetchTesti(); // Refresh testimonials
    } catch (error) {
      console.error("Error accepting comment:", error);
    }
    setTimeout(() => setAlertVisible(false), 2000);
    setAlertVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      const response = await Axios.patch(
        `/panel/${TESTIMONIAL}/${id}/reject`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-User-Role": userRole,
          },
        }
      );

      setAlert({
        message: "Comment deleted successfully",
        severity: "success",
      });
      fetchTesti(); // Refresh testimonials
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
    setTimeout(() => setAlertVisible(false), 2000);
    setAlertVisible(true);
  };

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      {/* Floating Alert */}
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setOpenAlert(false)}
      >
        <Alert
          onClose={() => setOpenAlert(false)}
          severity="info"
          sx={{ width: "100%" }}
        >
          New comment received!
        </Alert>
      </Snackbar>

      {alert && alertVisible && (
        <Alert
          severity={alert.severity}
          onClose={() => setAlertVisible(false)}
          sx={{
            transition: "opacity 1s ease-out",
            opacity: alertVisible ? 1 : 0,
          }}
        >
          {alert.message}
        </Alert>
      )}

      {pendingTesti.length > 0 ? (
        <Box sx={{ mt: 3 }}>
          <h3>Pending Comments</h3>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>ID</StyledTableCell>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell>Comment</StyledTableCell>
                  <StyledTableCell>Rating</StyledTableCell>
                  <StyledTableCell>Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pendingTesti.map((testi) => (
                  <StyledTableRow key={testi.id}>
                    <StyledTableCell>{testi.id}</StyledTableCell>
                    <StyledTableCell>{testi.name}</StyledTableCell>
                    <StyledTableCell>{testi.comment}</StyledTableCell>
                    <StyledTableCell>
                      <Rating value={testi.rating} precision={0.5} readOnly />
                    </StyledTableCell>
                    <StyledTableCell>
                      <IconButton
                        onClick={() => handleAccept(testi.id)}
                        color="success"
                      >
                        <CheckCircleOutlineIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => handleDelete(testi.id)}
                        color="error"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <Box sx={{ mt: 3, textAlign: "center", color: "gray", fontSize: 18 }}>
          No comments found
        </Box>
      )}
    </Box>
  );
}
